import { useLocation } from 'react-router-dom';

export const useIsSpanishRoute = (): boolean => useLocation().pathname.includes('/es/');
